// extracted by mini-css-extract-plugin
module.exports = {"network":"network_network__gnloD","list":"network_list__9UWRm","blindWrapClass":"network_blindWrapClass__KSVB0","link":"network_link__AQnz3"};